import {
  brazeInitialise,
  conditionsMetToTrackUser,
} from "@theconversation/shared-components/braze-tc"
import { currentUser } from "../currentUser"
import { emailToHash } from "@theconversation/shared-components/email-hash"

/**
 * This package is minimal glue between the Rails-specific features and the parts
 * that can exist in shared-components.
 */
export async function loadBrazeIfConditionsMet(sdkEndpoint: string, apiKey: string) {
  if (await conditionsMetToTrackUser()) {
    const user = await currentUser()
    const emailHash = user ? await emailToHash(user["email"]) : null

    brazeInitialise(sdkEndpoint, apiKey, emailHash)
  }
}
